import { UXBanner } from '../../../core/models/ux-page';
import { select, Store } from '@ngrx/store';
import * as fromBase from '../../../base/reducers';
import { AnalyticsService } from '../../../shared/services/analytics.service';
import { Router } from '@angular/router';
var BannerComponent = /** @class */ (function () {
    function BannerComponent(store, analyticsSvc, router) {
        this.store = store;
        this.analyticsSvc = analyticsSvc;
        this.router = router;
        this.type = 'home';
        this.fullWidthView$ = store
            .pipe(select(fromBase.isFullWidthViewEnabled));
    }
    BannerComponent.prototype.onButtonClick = function () {
        this.analyticsSvc.event('click', { event_category: 'Homebanner', event_label: this.title });
        this.router.navigate([this.buttonLink]);
    };
    Object.defineProperty(BannerComponent.prototype, "image", {
        get: function () {
            return this.banner.img;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BannerComponent.prototype, "hasTitle", {
        get: function () {
            return !!this.banner.title;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BannerComponent.prototype, "title", {
        get: function () {
            return this.banner.title;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BannerComponent.prototype, "hasSubTitle", {
        get: function () {
            return !!this.banner.subTitle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BannerComponent.prototype, "subTitle", {
        get: function () {
            return this.banner.subTitle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BannerComponent.prototype, "hasButton", {
        get: function () {
            return !!this.banner.link;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BannerComponent.prototype, "buttonLink", {
        get: function () {
            return "/" + this.banner.link;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BannerComponent.prototype, "buttonText", {
        get: function () {
            return this.banner.buttonText;
        },
        enumerable: true,
        configurable: true
    });
    return BannerComponent;
}());
export { BannerComponent };
